export const SET_CART_ATTEMPTS_COUNT = 'SET_CART_ATTEMPTS_COUNT'

export const setCartAttemptsCount = count => dispatch => {
	dispatch({ type: SET_CART_ATTEMPTS_COUNT, payload: count })
}



// WEBPACK FOOTER //
// ./src/actions/setUserSession.js